import React, { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";
type Props = {
  to: number;
  prefix?: string;
  suffix?: string;
  className?: string;
};
export function Counter({
  to,
  prefix = "",
  suffix = "",
  className
}: Props) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: "-40px"
  });
  const reduce = useReducedMotion();
  const [value, setValue] = useState(reduce ? to : 0);
  useEffect(() => {
    if (!inView || reduce) return;
    const controls = animate(0, to, {
      duration: 1.1,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: v => setValue(Math.round(v))
    });
    return () => controls.stop();
  }, [inView, reduce, to]);
  return <span ref={ref} className={className} aria-label={`${prefix}${to}${suffix}`} data-id="element-427" data-mp="3is5mn86ca7nz">
      <span aria-hidden data-id="element-428" data-mp="2laxgj0knwfj1">
        {prefix}
        {value}
        {suffix}
      </span>
    </span>;
}